import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import QRPage from "@/pages/QRPage";
import Templates from "@/pages/Templates";
import Messages from "@/pages/Messages";
import Settings from "@/pages/Settings";
import PublicForm from "@/pages/PublicForm";
import Billing from "@/pages/Billing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import AboutUs from "@/pages/AboutUs";
import ContactUs from "@/pages/ContactUs";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Refunds from "@/pages/Refunds";
import LogoPreview from "@/pages/LogoPreview";
import "@/App.css";

function ProtectedShell({ children, adminOnly = false }) {
  return (
    <ProtectedRoute adminOnly={adminOnly}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register/:regionSlug" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refunds" element={<Refunds />} />
            <Route path="/logo" element={<LogoPreview />} />
            <Route path="/f/:slug" element={<PublicForm />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/app" element={<ProtectedShell><Dashboard /></ProtectedShell>} />
            <Route path="/app/customers" element={<ProtectedShell><Customers /></ProtectedShell>} />
            <Route path="/app/qr" element={<ProtectedShell><QRPage /></ProtectedShell>} />
            <Route path="/app/templates" element={<ProtectedShell><Templates /></ProtectedShell>} />
            <Route path="/app/messages" element={<ProtectedShell><Messages /></ProtectedShell>} />
            <Route path="/app/settings" element={<ProtectedShell><Settings /></ProtectedShell>} />
            <Route path="/app/billing" element={<ProtectedShell><Billing /></ProtectedShell>} />
            <Route path="/admin" element={<ProtectedShell adminOnly><Admin /></ProtectedShell>} />
            <Route path="/app/admin" element={<ProtectedShell adminOnly><Admin /></ProtectedShell>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
